import { render, staticRenderFns } from "./safe-modal.vue?vue&type=template&id=0ef726ac&"
import script from "./safe-modal.vue?vue&type=script&lang=js&"
export * from "./safe-modal.vue?vue&type=script&lang=js&"
import style0 from "./safe-modal.vue?vue&type=style&index=0&id=0ef726ac&prod&lang=less&module=true&"




function injectStyles (context) {
  
  this["$style"] = (style0.locals || style0)

}

/* normalize component */
import normalizer from "!../../../../../../node_modules/vue-loader/lib/runtime/componentNormalizer.js"
var component = normalizer(
  script,
  render,
  staticRenderFns,
  false,
  injectStyles,
  null,
  null
  
)

export default component.exports